// extracted by mini-css-extract-plugin
export default {"loading_view":"loading_view--QEanD"};